export const RESPONSIVE_MOBILE_SMALL = 0;
export const RESPONSIVE_MOBILE_LARGE = 1;
export const RESPONSIVE_TABLET_SMALL = 2;
export const RESPONSIVE_TABLET_LARGE = 3;
export const RESPONSIVE_DESKTOP = 4;

export const AUTH_WRAPPER_COOKIE = 'AuthWrapper';

export const API_FETCH_LOGIN_WALL = '/api/get-signup-wall';

export const defaultJobProfileSnippet = { hash: null, isCompleted: false };

export const getBreakpointOnResize = (num) => {
    let breakpoint = null;
    let isMobile = false;

    if (num >= 1200) {
        breakpoint = RESPONSIVE_DESKTOP;
    } else if (num >= 992 && num < 1200) {
        breakpoint = RESPONSIVE_TABLET_LARGE;
        isMobile = true;
    } else if (num >= 576 && num < 992) {
        breakpoint = RESPONSIVE_TABLET_SMALL;
        isMobile = true;
    } else if (num >= 375 && num < 576) {
        breakpoint = RESPONSIVE_MOBILE_LARGE;
        isMobile = true;
    } else {
        breakpoint = RESPONSIVE_MOBILE_SMALL;
        isMobile = true;
    }

    return { breakpoint, isMobile };
};
